module.exports = __webpack_public_path__ + "static/media/PaySmartShopper.85206be8.png";